import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormArray, FormControl, Validators } from '@angular/forms';
import {
  NotificationOfEmergencyStageForm,
  NotificationOfEmergencyStageFormValue, toStageFormValue
} from './notification-of-emergency-stage.form';
import { RoadOccupationAppEntityApplicationRead } from '../../../../../../../openapi';

export function occupationsToFormValue(occupations: Array<RoadOccupationAppEntityApplicationRead>): NotificationOfEmergencyOccupationFormValue[] {
  return occupations.map(occupation => ({
    stages: occupation?.stages?.map(v => toStageFormValue(v)) || [],
    typeOfFailure: occupation.typeOfFailure || ''
  }));
}

export interface NotificationOfEmergencyOccupationFormValue {
  typeOfFailure: string;
  stages: NotificationOfEmergencyStageFormValue[];
}

@Injectable()
export class NotificationOfEmergencyOccupationForm extends AppForm {
  constructor() {
    super({
      typeOfFailure: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      stages: new FormArray([
        new NotificationOfEmergencyStageForm()
      ])
    });
  }

  public addStage(): void {
    this.stages.push(new NotificationOfEmergencyStageForm());
  }

  public removeStage(i: number): void {
    this.stages.removeAt(i);
  }

  public get stages(): FormArray {
    return this.get('stages') as FormArray;
  }

  public getStageForms(): NotificationOfEmergencyStageForm[] {
    return this.stages.controls as NotificationOfEmergencyStageForm[];
  }

  public override get valid(): boolean {
    return super.valid && !!this.stages.controls.map(c => c.valid).filter(v => v).length;
  }

  public override patchFormValues(value: NotificationOfEmergencyOccupationFormValue): void {
    super.patchFormValues(value);
    this.stages.clear();
    (value?.stages || []).forEach((v: NotificationOfEmergencyStageFormValue): void => {
      const sf = new NotificationOfEmergencyStageForm();
      sf.patchFormValues(v);
      this.stages.push(sf);
    });
  }

  public get values(): NotificationOfEmergencyOccupationFormValue {
    return {
      ...this.value,
      stages: this.getStageForms().map(v => v.values)
    };
  }
}
